module.exports = __webpack_public_path__ + "img/promo-students.221e41b6.jpg";